/**
 * @generated SignedSource<<ff9a357f927bbe17702b30bbcf4b9877>>
 * @relayHash 332e63384aed3d82bacaa936dab85e85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b72dbb4ba77248081b8adc546b0df52ce7f6d3a0305df9e9ef989d8d71a57c8

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type indexOldUnlinkIdeaMutation$variables = {
  cloudId: string;
  issueLinkId: string;
};
export type indexOldUnlinkIdeaMutation$data = {
  readonly jira: {
    readonly deleteIssueLink: {
      readonly deletedIds: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type indexOldUnlinkIdeaMutation = {
  response: indexOldUnlinkIdeaMutation$data;
  variables: indexOldUnlinkIdeaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueLinkId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueLinkId",
    "variableName": "issueLinkId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "deletedIds"
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "indexOldUnlinkIdeaMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDeleteIssueLinkPayload",
            "kind": "LinkedField",
            "name": "deleteIssueLink",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "indexOldUnlinkIdeaMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDeleteIssueLinkPayload",
            "kind": "LinkedField",
            "name": "deleteIssueLink",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3b72dbb4ba77248081b8adc546b0df52ce7f6d3a0305df9e9ef989d8d71a57c8",
    "metadata": {},
    "name": "indexOldUnlinkIdeaMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6ca7b89303c4170439984d7aa2df5a17";

export default node;
